var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrinterIcon = function SvgPrinterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M13 11v3H3v-3H1c-.552 0-1-.438-1-1.003V5.003A1 1 0 0 1 1 4h14c.552 0 1 .438 1 1.003v4.994A1 1 0 0 1 15 11zM3 0h10v3H3zm1 8v5h8V8zm10-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};
export default SvgPrinterIcon;